import { fragments as artOrderStatusFragments } from "../../application/apps/ArtApp/components/ArtOrderStatus/graph";
import { gql } from "@apollo/client";

const markOrderAsArtworkChangeRequestedMutation = gql`
  mutation($description: String!, $orderId: ID!) {
    markOrderAsArtworkChangeRequested(
      description: $description
      orderId: $orderId
    ) {
      errors {
        description
        orderId
      }
      createdArtworkChange {
        changedAt
        description
        employee {
          id
          name_artworkOrderStatus: name(format: FIRST_NAME_LAST_NAME)
        }
        id
      }
      updatedOrder {
        ...ArtOrderStatus_order
      }
      succeeded
    }
  }
  ${artOrderStatusFragments.order}
`;

export default markOrderAsArtworkChangeRequestedMutation;
